<template>
  <div class="aside-layout">
    <Logo></Logo>
    <el-aside :width="isCollapse ? '64px' : '280px'">
      <el-menu
        ref="elMenu"
        :default-active="defaultActive"
        :default-openeds="defaultOpen"
        class="el-menu-vertical-demo"
        @open="handleOpen"
        @close="handleClose"
        @select="handleSelectItem"
        :collapse="isCollapse"
      >
        <sub-menu-item :menu-data="menuData"></sub-menu-item>
      </el-menu>
    </el-aside>
  </div>
</template>
<script>
import Logo from "@/components/Layout/Logo.vue";
import { mapState, mapActions } from "vuex";
import subMenuItem from "./subMenuItem.vue";
export default {
  data() {
    return {
      menuData: [],
      defaultOpen: [],
    };
  },
  components: {
    Logo,
    subMenuItem,
  },
  computed: {
    ...mapState(["isCollapse", "menus", "menuList", "defaultActive"]),
  },
  watch: {
    menus: {
      handler(data) {
        this.menuData = data.length ? data[0].children : [];
      },
      deep: true,
      immediate: true,
    },
    // defaultActive: {
    //   handler(val) {
    //     const currMenu = this.menuList.find((menu) => menu.url === val);
    //     if (currMenu) {
    //       const parentItem = this.menuList.find(
    //         (menu) => menu.menuId == currMenu.parentId
    //       );
    //       this.defaultOpen = [parentItem.url];
    //     }
    //   },
    //   immediate: true,
    // },
  },
  methods: {
    ...mapActions(["handleGetUserMenu", "handleSetCurrentRole", "handleSetAsideOpen"]),
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleSelectItem(key, keyPath) {
      if (key == "/index") {
        this.handleSetCurrentRole(false);
      }
      this.handleSetAsideOpen(key);
      this.$router.push({
        path: key,
      });
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  },
  created() {},
};
</script>
<style lang="less" scoped>
.el-aside {
  background-color: #fff;
  color: #333;
  height: 100%;
  text-align: center;
  line-height: 200px;
}
.aside-layout {
  position: relative;
  background: #fff;
  display: flex;
  flex-direction: column;
  z-index: 1000;
  box-shadow: 2px 3px 2px #f2f2f2;
}

.el-menu-vertical-demo {
  padding-bottom: 80px;
}

/deep/ .el-menu {
  border-right: none;
}
</style>
